import { UseCase } from "../../useCase"
import { GetSurveysResponse } from "./response"
import { GetSurveysRequest } from "./request"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class GetSurveysUseCase implements UseCase<GetSurveysRequest, GetSurveysResponse> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec() {
		return this._repository.getSurveys()
	}
}
